export function getURLParams(url: string): { [key: string]: string } {
  const params = {};
  const parser = document.createElement('a');
  parser.href = url;
  const query = parser.search.substring(1);
  const vars = query.split('&').filter(item => !!item);
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    params[pair[0]] = decodeURIComponent(pair[1]);
  }
  return params;
}

export function getURLWithoutParams(url: string): string {
  return url ? url.split('?')[0] : null;
}

export function getURLWithoutAnchor(url: string): string {
  const _url = url.split('#');
  return _url[0];
}

export function getAnchorFromURL(url: string): string {
  const _url = url.split('#');
  return _url && _url.length > 1 ? _url[1] : null;
}
